import React, { Component } from "react"
import { Button, Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import jwt from "jsonwebtoken"
import ido from "idexo-sdk"

class CreateCollection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedFiles: [],
            name: "",
            symbol: ""
        }
    }

    handleAcceptedFiles = (files) => {
        files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: this.formatBytes(file.size)
            })
        )

        this.setState({ selectedFiles: files })
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.sendCreate(this.state.name, this.state.symbol).then(console.log)
    }

    sendCreate = async (name, symbol) => {
        var decoded = jwt.decode(localStorage.jwtToken)
        const contract = await ido.Binance.deployBEP721(name, symbol, decoded.api_key)
        alert("Contract successfully deployed. Address is: " + contract)
    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">Create NFT Collection Token</CardTitle>
                                    <p className="card-title-desc">Provide a name and a symbol and select your network</p>

                                    <Form>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="name">Name</Label>
                                                    <Input
                                                        id="name"
                                                        name="name"
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => this.setState({ name: e.target.value })}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="symbol">Symbol</Label>
                                                    <Input
                                                        id="symbol"
                                                        name="symbol"
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => this.setState({ symbol: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="control-label">Network</Label>
                                                    <select className="form-control select2">
                                                        <option>Select</option>
                                                        <option value="BSC">Binance Smart Chain</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="d-flex flex-wrap gap-2">
                                            <Button type="submit" color="primary" className="waves-effect waves-light" onClick={this.handleSubmit}>
                                                Create
                                            </Button>
                                            <Button type="submit" color="secondary" className="waves-effect waves-light">
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default CreateCollection
